import { Displaying } from "@bonusx-global/bx-design-system";
import Box from "@mui/material/Box";
import { useAtomValue } from "jotai";
import type { PropsWithChildren } from "react";
import { memo } from "react";
import type { RouteWrapperVariant } from "../../../constants/layouts/route-wrapper-variant.enum";
import { useRouteWrapperState } from "../../../hooks/layout/use-route-wrapper-state/useRouteWrapperState";
import { SearchSelectIsVisible } from "../../../legacy/stores/search/search";
import { BonusXThemeProvider } from "../../../legacy/theme/BonusXThemeProvider";
import type { IRouteWrapperGetVariant } from "../../../types/layout/route-wrapper-variant.interface";

interface BaseRouterWrapperProps extends IRouteWrapperGetVariant {
  readonly useLegacyDesign?: boolean;
  readonly variant?: RouteWrapperVariant;
  readonly defaultCloseButtonModal?: JSX.Element;
}

export type RouteWrapperProps = BaseRouterWrapperProps;
export const ROUTE_WRAPPER_ID = "route-wrapper";

function RouteWrapper({
  children,
  variant,
  useLegacyDesign = false,
  defaultBackButtonUrl,
  showLogo,
  progressBar,
  progressBarPercentage,
  title,
  defaultCloseButtonModal: closeButtonModal,
}: PropsWithChildren<RouteWrapperProps>): JSX.Element {
  useRouteWrapperState({
    variant,
    defaultBackButtonUrl,
    showLogo,
    title,
    defaultCloseButtonModal: closeButtonModal,
    progressBar,
    progressBarPercentage,
  });
  const isSearchPanelVisible = useAtomValue(SearchSelectIsVisible);

  const contentWrapper = (
    <Box id={ROUTE_WRAPPER_ID} display={isSearchPanelVisible ? Displaying.none : Displaying.block} height={"100%"}>
      {children}
    </Box>
  );

  if (useLegacyDesign) {
    return contentWrapper;
  }

  return <BonusXThemeProvider>{contentWrapper}</BonusXThemeProvider>;
}

export default memo(RouteWrapper);
